import { roles } from "shared/constants/Constants.js";

const performanceRoutes = {
  dashboard: [
    {
      path: "performance_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "driver-performance" */
          "../../feature/performance/DriverPerformance.js"
        ),
      authorized: [roles.VENDOR, roles.DRIVER_MANAGER, roles.SENIOR_DRIVER_MANAGER],
      sidebarGroup: "performance",
      sidebarLabel: "Driver",
    },
    {
      path: "fleetPerformance",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "fleet-performance" */
          "../../feature/performance/FleetPerformance.js"
        ),
      authorized: [roles.VENDOR, roles.DRIVER_MANAGER, roles.SENIOR_DRIVER_MANAGER],
      sidebarGroup: "performance",
      sidebarLabel: "Fleet",
    },
  ],
  standalone: [],
};

export default performanceRoutes;
